import axios from 'axios';

export const getValidationStatuses = async (type, query = {}) => {
  const params = new URLSearchParams();

  Object.entries(query).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach(v => {
        if (v !== undefined && v !== null && v !== '') {
          params.append(key, v);
        }
      });
    } else if (value !== undefined && value !== null && value !== '') {
      params.append(key, value);
    }
  });

  const queryString = params.toString();
  const url = `/reports/${type}/statuses/${queryString ? `?${queryString}` : ''}`;
  const response = await axios.get(url);
  return response;
};

export const getValidationStatusesForce = async (reportType, reportId) => {
  const url = `/validations/${reportType}/${reportId}/force/`;
  const response = await axios.get(url);
  return response;
};

export const updateValidationStatusForce = async (reportType, reportId, status) => {
  const url = `/validations/${reportType}/${reportId}/force/`;
  const response = await axios.put(url, { status });
  return response;
};

export const getTCPFilters = async (filter) => {
  const url = `/reports/clearance/clearance-tasks/filters/choices/?choice_name=${filter}`;
  const response = await axios.get(url);
  return response;
};

export const getOptionsForClearance = async (type) => {
  const url = `/reports/clearance/clearance-tasks/filters/choices/?choice_name=${type}`;
  const response = await axios.get(url);
  return response;
};

export const getEoreOptions = async (optionType) => {
  const url = `/reports/eore/filters/choices/?choice_name=${optionType}`;
  const response = await axios.get(url);
  return response;
};

export const getEoreFilterOptions = async () => {
  const url = `/reports/eore/filters/`;
  const response = await axios.get(url);
  return response;
};

export const getNtsHaOptions = async (reportType, optionType) => {
  const url = `/reports/${reportType}/filters/choices/?choice_name=${optionType}`;
  const response = await axios.get(url);
  return response;
};

export const getNtsHaFilterOptions = async (reportType) => {
  const url = `/reports/${reportType}/filters/`;
  const response = await axios.get(url);
  return response;
};
